var _defs, _title;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "300 400 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-About_us_project_ranking_info"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1299.903,
    height: 1023.307
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.203653, 0, 0, 1.190576, -836.088196, -371.082428)",
    style: {
      clipPath: "url(#clip-About_us_project_ranking_info)"
    }
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "E")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    className: "cls-15",
    cx: 1023.44,
    cy: 729.273,
    r: 70.317,
    style: {
      fill: "rgb(255, 127, 41)",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_406",
    "data-name": "Line 406",
    className: "cls-11",
    x2: 1062.51,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    },
    x1: 982.574,
    y1: 734.869,
    y2: 734.869
  }), /*#__PURE__*/React.createElement("text", {
    id: "E",
    className: "cls-13",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Bold, Assistant",
      fontSize: "54.585px",
      fontWeight: 700,
      letterSpacing: "0.54585px",
      lineHeight: "87.336px",
      perspectiveOrigin: "23.7344px 34px"
    },
    x: 997.609,
    y: 666.253
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1008.134,
    y: 722.253,
    style: {
      fontSize: "54.6px",
      wordSpacing: 0,
      letterSpacing: "0.55px"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "_0-34",
    "data-name": "0-34",
    className: "cls-14",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Bold, Assistant",
      fontSize: 30,
      fontWeight: 700,
      lineHeight: 48,
      perspectiveOrigin: "34.9062px 18.5px"
    },
    x: 978.942,
    y: 735.443
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 993.774,
    y: 766.443,
    style: {
      fontSize: 30,
      wordSpacing: 0
    }
  }, "0-34"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE);
export default __webpack_public_path__ + "static/media/E.aa6caf359632c88fad0a8132eb5aeecd.svg";
export { ForwardRef as ReactComponent };